// extracted by mini-css-extract-plugin
module.exports = {"input":"wRmb9h","label":"Yz-IwB","radio":"LQPH6K"};